export const CUSTOM_AGENTS_SECTION_ANCHOR_ID = 'custom-agents-section';
